import { defineComponent as l, computed as r, createElementBlock as i, openBlock as n, mergeProps as s, unref as t, createCommentVNode as d, createBlock as b, normalizeClass as h, createVNode as v, resolveDynamicComponent as B, withCtx as y, renderSlot as I } from "vue";
import a from "../../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/Breadcrumb/breadcrumb.js";
import w from "../../helpers/PassThrough.vue2.js";
import { AngleRightIcon as C } from "../../packages/icons/dist/esm/icons/angle-right-icon.js";
import { useOUIAProps as g } from "../../helpers/ouia.js";
const N = /* @__PURE__ */ l({
  name: "PfBreadcrumbItem",
  inheritAttrs: !1,
  __name: "BreadcrumbItem",
  props: {
    href: {},
    to: {},
    active: { type: Boolean },
    dropdown: { type: Boolean },
    showDivider: { type: Boolean },
    component: {},
    liAttrs: {},
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  },
  setup(m) {
    const e = m, p = g({ id: e.ouiaId, safe: e.ouiaSafe }), u = r(() => e.active && !e.to ? "page" : void 0), c = r(() => typeof e.component == "object" ? e.component.name === "PfButton" : e.component === "button" || e.component === "pf-button"), f = r(() => e.component ? e.component : e.dropdown ? "span" : e.to ? "router-link" : e.href ? "a" : w);
    return (o, k) => (n(), i("li", s({ ...t(p), ...o.liAttrs }, {
      class: t(a).breadcrumbItem
    }), [
      o.showDivider ? (n(), i("span", {
        key: 0,
        class: h(t(a).breadcrumbItemDivider)
      }, [
        v(t(C))
      ], 2)) : d("", !0),
      (n(), b(B(f.value), s(o.$attrs, {
        to: o.to,
        href: o.href,
        "aria-current": u.value,
        class: {
          [t(a).breadcrumbDropdown]: o.dropdown
        },
        type: c.value ? "button" : void 0
      }), {
        default: y(() => [
          I(o.$slots, "default")
        ]),
        _: 3
      }, 16, ["to", "href", "aria-current", "class", "type"]))
    ], 16));
  }
});
export {
  N as default
};
